// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // apiUrl: 'https://api.paynowafrica.com/',
  apiUrl: 'https://app.alias-solutions.net:5001/',
  api: 'https://api.alias-solutions.net:8001/api/services/app/',
  imageUrl: 'https://api.paynowafrica.com/Files/',
  firebase: {
    apiKey: 'AIzaSyBUDgMtElCaHYxgdZpehxiWg5LQFiFIySE',
    authDomain: 'paynowafrica.firebaseapp.com',
    databaseURL: 'https://paynowafrica.firebaseio.com',
    projectId: 'paynowafrica',
    storageBucket: 'paynowafrica.appspot.com',
    messagingSenderId: '287500243914',
    appId: '1:287500243914:web:b49403c871c54856'
  }
};

export const config = {
  // apiUrl: 'http://192.168.1.102:8443/chatbotapi/',
  // imageUrl: 'http://192.168.1.102:8443/chatbotapi/Files/',
  // apiUrl: 'https://api.paynowafrica.com/',
  apiUrl: 'https://app.alias-solutions.net:5001/',
  api: 'https://api.alias-solutions.net:8001/api/services/app/',
  imageUrl: 'https://api.paynowafrica.com/Files/',
  firebase: {
    apiKey: 'AIzaSyBUDgMtElCaHYxgdZpehxiWg5LQFiFIySE',
    authDomain: 'paynowafrica.firebaseapp.com',
    databaseURL: 'https://paynowafrica.firebaseio.com',
    projectId: 'paynowafrica',
    storageBucket: 'paynowafrica.appspot.com',
    messagingSenderId: '287500243914',
    appId: '1:287500243914:web:b49403c871c54856'
  }
};


/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
